import BaseTheme from "../theme/BaseTheme";
import { Outlet } from "react-router-dom";
import { Container } from "@radix-ui/themes";

export default function FullPageLayout() {
  return (
    <BaseTheme>
      <Container>
        <Outlet />
      </Container>
    </BaseTheme>
  );
}
